import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MaterialModal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { useSpring, animated } from 'react-spring';
import { CrossIcon } from '../Svg';
import { withModal } from '../wrappers/withModal';
import * as modals from '../../Popups/Modals';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: '0',
  },
}));

const defaultOptions = {
  showCloseButton: true,
};

const Fade = React.forwardRef((props, ref) => {
  const {
    in: open, children, onEnter, onExited, ...other
  } = props;
  const style = useSpring({
    from: { opacity: 0, outline: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

const Modal = ({ modalContext }) => {
  const { componentProps, options = {}, ...props } = modalContext;
  const allProps = { ...componentProps, ...props };
  const classes = useStyles();
  const { componentType, isOpen, closeModal } = props;
  const Component = modals[componentType];

  const renderCloseButton = () => (
    <button
      type="button"
      className="absolute cursor-pointer z-10"
      style={{ right: 10, top: 10 }}
      onClick={closeModal}
    >
      <CrossIcon />
    </button>
  );

  return (
    <div className="outline-none">
      <MaterialModal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={isOpen}
        onClose={closeModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        disableBackdropClick={options.disableBackdropClick}
      >
        <Fade in={isOpen}>
          {Component && (
            <div className="relative">
              {(options.showCloseButton !== undefined
                ? options.showCloseButton
                : defaultOptions.showCloseButton) && renderCloseButton()}
              <Component {...allProps} />
            </div>
          )}
        </Fade>
      </MaterialModal>
    </div>
  );
};

export default withModal(Modal);
